<template>
  <div id="app" v-cloak>
    <!--<keep-alive exclude="Messenger">-->
      <router-view/>
    <!--</keep-alive>-->
  </div>
</template>

<script>
//import CONFIG from '@/constants/config.js';
import {settingsMixin} from '@/utils/settings-mixin'
export default {
  name: 'App',
  mixins: [settingsMixin],
  components:{
  },
  beforeCreate(){
    /* Initial request to get session and set Cookie as default*/
    if(this.$store){
      console.log('Ready for initial request')
    }

    /* Add hidden overflow  */
    // console.log(this.$vuetify.breakpoint.smAndDown);
    if(this.$vuetify.breakpoint.smAndDown){
      var htmlElement = document.querySelector("html");
      if(htmlElement){
        htmlElement.style.overflow = "hidden";
      }
    }
  },
  mounted() {
    // catch the first user gesture (the login tap) to unlock task audio for later autoplay (iOS Safari)
    this.$store.dispatch('taskaudio/primeUnlock');
  },
  updated() {
    // debugger;
  }
};
</script>

<style lang="scss">
@import './assets/global.css';
</style>
